import { ROLE_VALUE } from '.';

interface Map {
  [key: number]: string[];
}

/**
 *  ----------------------------------- SCHOOL ---------------------------
 */

/**
 * admin-user permission matrix
 * (TODO): get from database
 */
const SCHOOL_ROUTER_BASIC_FUNCTION = [
  // Home
  '/[schoolSlug]',

  // Home
  '/[schoolSlug]/schedule',

  // Acount register
  '/[schoolSlug]/setting/account/register',

  // Attendance
  '/[schoolSlug]/attendance/[eventDateID]',

  // Event
  '/[schoolSlug]/event',
  '/[schoolSlug]/event/add',
  '/[schoolSlug]/event/edit/[id]',

  // Lesson
  '/[schoolSlug]/lesson',
  '/[schoolSlug]/lesson/add',
  '/[schoolSlug]/lesson/edit/[id]',

  // member-management => group-member
  '/[schoolSlug]/member-management',
  '/[schoolSlug]/member-management/group-member',
  '/[schoolSlug]/member-management/group-member/add',
  '/[schoolSlug]/member-management/group-member/edit/[group_id]',

  // member-management => member list
  '/[schoolSlug]/member-management/member',

  // member-management => member detail
  '/[schoolSlug]/member-management/member/[id]',

  // member-management => lesson
  '/[schoolSlug]/member-management/member/[id]/lesson',
  '/[schoolSlug]/member-management/member/[id]/payment/add',
  '/[schoolSlug]/member-management/member/[id]/payment/delete',
  '/[schoolSlug]/member-management/member/[id]/payment/edit/[memberPaymentId]',

  // member-management => reserve
  '/[schoolSlug]/member-management/member/[id]/reserve',

  // member-management => school-information
  '/[schoolSlug]/member-management/member/[id]/school-information',
  '/[schoolSlug]/member-management/member/[id]/school-information/plan-settings',
  '/[schoolSlug]/member-management/member/[id]/school-information/plan-settings/edit/[memberPlanId]',

  // member-management => ticket-history
  '/[schoolSlug]/member-management/member/[id]/ticket-history',

  // reader-qr
  '/[schoolSlug]/reader-qr',

  // reservation
  '/[schoolSlug]/reservation',

  // school setting => coach
  '/[schoolSlug]/setting/coach',
  '/[schoolSlug]/setting/coach/add',
  '/[schoolSlug]/setting/coach/edit/[id]',

  // school setting => importschedule
  '/[schoolSlug]/setting/importschedule',

  // school setting => level
  '/[schoolSlug]/setting/level',
  '/[schoolSlug]/setting/level/add',
  '/[schoolSlug]/setting/level/edit/[id]',

  // school setting => level
  '/[schoolSlug]/setting/level',
  '/[schoolSlug]/setting/level/add',
  '/[schoolSlug]/setting/level/edit/[id]',

  // school setting => notification
  '/[schoolSlug]/setting/notification',
  '/[schoolSlug]/setting/notification/add',
  '/[schoolSlug]/setting/notification/edit/[id]',

  // edit schedule
  '/[schoolSlug]/schedule/edit/[lessonId]',

  // school setting => plan
  '/[schoolSlug]/setting/plan',
  '/[schoolSlug]/setting/plan/add',
  '/[schoolSlug]/setting/plan/edit/[id]',

  // school setting => playground
  '/[schoolSlug]/setting/playground',
  '/[schoolSlug]/setting/playground/add',
  '/[schoolSlug]/setting/playground/edit/[id]',

  // school setting => questionnaire
  '/[schoolSlug]/setting/questionnaire',

  // school setting => sale off
  '/[schoolSlug]/setting/sale-off',
  '/[schoolSlug]/setting/sale-off/add',
  '/[schoolSlug]/setting/sale-off/edit/[id]',

  // school setting => school
  '/[schoolSlug]/setting/school',

  // school setting => ticket
  '/[schoolSlug]/setting/ticket',
  '/[schoolSlug]/setting/ticket/add',
  '/[schoolSlug]/setting/ticket/edit/[id]',
  '/[schoolSlug]/setting/ticket/ticket-issue/[id]',

  // email recover
  '/[schoolSlug]/email_recover',

  // email_recover_invalid
  '/[schoolSlug]/email_recover_invalid',

  // password_reset
  '/[schoolSlug]/password_reset',

  // password_reset_invalid
  '/[schoolSlug]/password_reset_invalid',

  // account => information
  '/[schoolSlug]/setting/account/information',
  '/[schoolSlug]/setting/account/edit/[id]',

  // login
  '/[schoolSlug]/login',

  // School setting => semester
  '/[schoolSlug]/setting/semester',
  '/[schoolSlug]/setting/semester/add',
  '/[schoolSlug]/setting/semester/edit/[id]',
];

const PRIVATE_FUNCTION = [
  // dashboard
  '/[schoolSlug]/dashboard',

  // payment billing
  '/[schoolSlug]/payment/billing',
  // gmo-cooperation
  '/[schoolSlug]/payment/gmo-cooperation',
  // management
  '/[schoolSlug]/payment/management',
  // system-linkage
  '/[schoolSlug]/payment/system-linkage',
  // transfer-ticket
  '/[schoolSlug]/payment/transfer-ticket',
];

const ACCOUNT_SETTING = [
  // acount
  '/[schoolSlug]/account',
  '/[schoolSlug]/account/add',
  '/[schoolSlug]/account/[id]',
];

const PUBLIC_FUNCTION = [
  '/[schoolSlug]',

  '/[schoolSlug]/email_recover',

  // email_recover_invalid
  '/[schoolSlug]/email_recover_invalid',

  // password_reset
  '/[schoolSlug]/password_reset',

  // password_reset_invalid
  '/[schoolSlug]/password_reset_invalid',

  // account => information
  '/[schoolSlug]/setting/account/information',
  '/[schoolSlug]/setting/account/edit/[id]',
];

export const SCHOOL_PERMISSION: Map = {
  0: [...PUBLIC_FUNCTION],

  // Admin Permission (ROLE = 1) FULL ACCESS
  [ROLE_VALUE.ADMIN]: [...ACCOUNT_SETTING, ...PUBLIC_FUNCTION, ...SCHOOL_ROUTER_BASIC_FUNCTION, ...PRIVATE_FUNCTION],

  // Partner permisson (ROLE = 2) ACCESS ONLY HOME + ATTENDANCE
  [ROLE_VALUE.PARTNER]: [
    ...PUBLIC_FUNCTION,

    // Attendance
    '/[schoolSlug]/attendance/[eventDateID]',

    '/[schoolSlug]/schedule',

    // reader-qr
    '/[schoolSlug]/reader-qr',
  ],

  // Staff Permission (ROLE = 3) FULL ACCESS except payment + account setting
  [ROLE_VALUE.STAFF]: [...PUBLIC_FUNCTION, ...SCHOOL_ROUTER_BASIC_FUNCTION],
};

/**
 *  ----------------------------------- TOURNAMENT ---------------------------
 */

const TOURNAMENT_BASIC = [
  // login
  '/[schoolSlug]/login',

  // tournament
  '/[schoolSlug]/tournament-list',

  '/[schoolSlug]/tournament/[tournament_id]',
  '/[schoolSlug]/tournament/[tournament_id]/apply-list',
  '/[schoolSlug]/tournament/[tournament_id]/attendance-list',
  '/[schoolSlug]/tournament/[tournament_id]/claim',

  '/[schoolSlug]/tournament/[tournament_id]/sub-tournament-list',

  '/[schoolSlug]/tournament/[tournament_id]/group/knockout',
  '/[schoolSlug]/tournament/[tournament_id]/group/knockout/edit/[group_id]',
  '/[schoolSlug]/tournament/[tournament_id]/group/knockout/add',

  '/[schoolSlug]/tournament/[tournament_id]/group/league',
  '/[schoolSlug]/tournament/[tournament_id]/group/league/edit/[group_id]',
  '/[schoolSlug]/tournament/[tournament_id]/group/league/add',

  '/[schoolSlug]/tournament/[tournament_id]/group/[group_id]',

  // Schedule
  '/[schoolSlug]/tournament/[tournament_id]/schedule',
  '/[schoolSlug]/tournament/[tournament_id]/schedule/add',

  // setting
  '/[schoolSlug]/tournament/[tournament_id]/setting/attracting-customer',
  '/[schoolSlug]/tournament/[tournament_id]/setting/basic-config',
  '/[schoolSlug]/tournament/[tournament_id]/setting/multiple-basic-config',

  '/[schoolSlug]/tournament/[tournament_id]/setting/court',
  '/[schoolSlug]/tournament/[tournament_id]/setting/court/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/court/edit/[id]',
  '/[schoolSlug]/tournament/[tournament_id]/setting/help-school',
  '/[schoolSlug]/tournament/[tournament_id]/setting/help-school/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/help-school/edit/[id]',
  '/[schoolSlug]/tournament/[tournament_id]/setting/sponsors',
  '/[schoolSlug]/tournament/[tournament_id]/setting/sponsors/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/sponsors/edit/[id]',
  '/[schoolSlug]/tournament/[tournament_id]/setting/level',
  '/[schoolSlug]/tournament/[tournament_id]/setting/level/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/level/edit/[id]',
  '/[schoolSlug]/tournament/[tournament_id]/setting/notification',
  '/[schoolSlug]/tournament/[tournament_id]/setting/notification/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/notification/edit/[id]',

  '/[schoolSlug]/tournament/[tournament_id]/setting/invite-code',
  '/[schoolSlug]/tournament/[tournament_id]/setting/invite-code/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/invite-code/edit/[id]',

  // account => information
  '/[schoolSlug]/setting/account/information',
  '/[schoolSlug]/setting/account/edit/[id]',
];

const TOURNAMENT_PARTNER_ACCOUNT = [
  '/[schoolSlug]/tournament/[tournament_id]/setting/account',
  '/[schoolSlug]/tournament/[tournament_id]/setting/account/add',
  '/[schoolSlug]/tournament/[tournament_id]/setting/account/edit',
];

export const TOURNAMENT_PERMISSON: Map = {
  0: [...PUBLIC_FUNCTION],
  // Admin
  [ROLE_VALUE.ADMIN]: [...ACCOUNT_SETTING, ...PUBLIC_FUNCTION, ...TOURNAMENT_BASIC, ...TOURNAMENT_PARTNER_ACCOUNT],
  // Partner
  [ROLE_VALUE.PARTNER]: [...PUBLIC_FUNCTION, ...TOURNAMENT_BASIC],
  // Staff
  [ROLE_VALUE.STAFF]: [...PUBLIC_FUNCTION, ...TOURNAMENT_BASIC, ...TOURNAMENT_PARTNER_ACCOUNT],
};

/**
 *  ----------------------------------- COURT RENTALS--------------------------
 */

export const COURT_RENTALS = [
  '/[schoolSlug]/rental/setting',
  '/[schoolSlug]/rental/facility-list',
  '/[schoolSlug]/rental/[facility_id]/court-list',
  '/[schoolSlug]/rental/[facility_id]/court-list/[id]/edit',
  '/[schoolSlug]/rental/[facility_id]/schedule',
  '/[schoolSlug]/rental/[facility_id]/schedule/edit',
  '/[schoolSlug]/rental/[facility_id]/setting/price/[id]',
  '/[schoolSlug]/rental/[facility_id]/setting/price/create',
  '/[schoolSlug]/rental/[facility_id]/setting/price',
  '/[schoolSlug]/rental/[facility_id]/apply-list',
  '/[schoolSlug]/rental/[facility_id]/setting/basic-setting',
  '/[schoolSlug]/rental/[facility_id]/setting/information',
  '/[schoolSlug]/rental/[facility_id]/setting/information/add',
  '/[schoolSlug]/rental/[facility_id]/setting/information/edit/[id]',
];

export const COURT_RENTAL_PERMISSION: Map = {
  0: [...PUBLIC_FUNCTION],
  [ROLE_VALUE.ADMIN]: [...ACCOUNT_SETTING, ...COURT_RENTALS],
  [ROLE_VALUE.STAFF]: [...COURT_RENTALS],
};
